import Vue from 'vue'
import Vuetify from 'vuetify'
import fr from 'vuetify/es5/locale/fr';
import 'vuetify/dist/vuetify.min.css'
import '@mdi/font/css/materialdesignicons.css'

import '../style/main.css'

Vue.use(Vuetify)
const opts = {
    theme: {
        dark: false,
        themes: {
            light: {
                primary: '#F40009',
                red: '#F40009',
                error: '#F40009',
                success: '#38cb89',
                secondary: '#1E1E1E',
            }
        },
    },
    lang: {
        locales: {fr},
        current: 'fr',
    },
    icons: {
        iconfont: 'mdi',
    },
}
export default new Vuetify(opts)
